import styled from "styled-components";

export const RightDiv = styled("div")`
  float: right;
`;
RightDiv.displayName = "RightDiv";
